import { render, staticRenderFns } from "./InstructorIndex.vue?vue&type=template&id=83cf3b5c&scoped=true&"
import script from "./InstructorIndex.vue?vue&type=script&lang=js&"
export * from "./InstructorIndex.vue?vue&type=script&lang=js&"
import style0 from "./InstructorIndex.vue?vue&type=style&index=0&id=83cf3b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cf3b5c",
  null
  
)

export default component.exports